// Gerçek uygulama ekranları: web/tablet/mobil varyantlı responsive WebP çerçeveleri.
const SCREEN_ALIASES = {
  "web-panel": "web-ozet",
  "web-personel": "web-ik-plus",
  "web-pos": "web-pos",
  "mobil-panel": "mobil-ozet",
  "mobil-gelir-gider": "mobil-bireysel-butce",
};

const marketingPath = (name) => {
  const resolved = SCREEN_ALIASES[name] || name;
  if (/^(web|tablet|mobil)-/.test(resolved)) return `/assets/marketing/v2/${resolved}.webp`;
  return `/assets/marketing/v2/web-${resolved}.webp`;
};

export const scr = (name) => marketingPath(name);

const V2_RE = /\/assets\/marketing\/v2\/(web|tablet|mobil)-(.+)\.webp$/;

// CLS önleme: v2 görsellerin doğal boyutları (PIL ile doğrulandı)
const V2_DIMS = { web: [1920, 1080], tablet: [1024, 1366], mobil: [390, 844] };
// Müşteriden gelen bu 4 görselin mobil/tablet varyantı YOK; web boyutları da farklı (1600x950)
const V2_WEB_ONLY = {
  "alis-faturalari": [1600, 950],
  "cek-senet": [1600, 950],
  "proje-yonetimi": [1600, 950],
  "tedarikciler": [1600, 950],
};

export const screenSrc = (path) => {
  const match = path.match(V2_RE);
  if (match) {
    const screen = match[2];
    // Varyantı olmayan görsellerde var olmayan mobil/tablet adayı üretme (404/bozuk görsel önlenir)
    if (V2_WEB_ONLY[screen]) return { src: path, srcSet: undefined };
    return {
      src: path,
      srcSet: [
        `/assets/marketing/v2/mobil-${screen}.webp 390w`,
        `/assets/marketing/v2/tablet-${screen}.webp 1024w`,
        `/assets/marketing/v2/web-${screen}.webp 1920w`,
      ].join(", "),
    };
  }

  // Eski eklenti görselleri için retina varyantı.
  if (path.startsWith("/assets/") && path.endsWith(".webp") && !path.includes("@1x")) {
    const one = path.replace(".webp", "@1x.webp");
    return { src: path, srcSet: `${one} 840w, ${path} 1680w` };
  }
  return { src: path, srcSet: undefined };
};

export const BrowserFrame = ({ src, alt, className = "", loading = "lazy" }) => {
  const m = src.match(V2_RE);
  const screen = m ? m[2] : null;
  const only = screen ? V2_WEB_ONLY[screen] : null;
  const dims = only || (m ? V2_DIMS[m[1]] : null);
  const s = m ? null : screenSrc(src);
  return (
    <div className={`overflow-hidden rounded-xl border border-black/10 bg-white shadow-2xl ${className}`} data-testid="browser-frame">
      <div className="flex items-center gap-2 border-b border-black/10 bg-[#f2f2f4] px-3 py-2">
        <span className="flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-[#ff5f57]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#febc2e]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#28c840]" />
        </span>
        <span className="ml-2 flex-1 truncate rounded-md border border-black/5 bg-white px-3 py-1 font-mono-tech text-[10px] tracking-wide text-black/40">
          giris.parasyo.com
        </span>
      </div>
      {m && !only ? (
        // Varyantları olan v2 görseller: her cihaz boyutuna kendi varyantı + doğru en/boy (CLS yok)
        <picture>
          <source media="(max-width: 768px)" srcSet={`/assets/marketing/v2/mobil-${screen}.webp`} width="390" height="844" />
          <source media="(max-width: 1280px)" srcSet={`/assets/marketing/v2/tablet-${screen}.webp`} width="1024" height="1366" />
          <img
            src={`/assets/marketing/v2/web-${screen}.webp`}
            alt={alt}
            loading={loading}
            width={V2_DIMS.web[0]}
            height={V2_DIMS.web[1]}
            className="block h-auto w-full"
          />
        </picture>
      ) : (
        <img
          src={m ? src : s.src}
          srcSet={m ? undefined : s.srcSet}
          sizes={m ? undefined : "(max-width: 768px) 390px, (max-width: 1280px) 1024px, 1920px"}
          alt={alt}
          loading={loading}
          width={dims ? dims[0] : undefined}
          height={dims ? dims[1] : undefined}
          className="block h-auto w-full"
        />
      )}
    </div>
  );
};

// Telefon çerçevesi her zaman dikey mobil varyantı gösterir; yüksek DPR ekranlarda
// tarayıcının yatay tablet/web varyantını seçmesi engellenir.
const mobileOnlySrc = (path) => {
  const match = path.match(V2_RE);
  return match ? `/assets/marketing/v2/mobil-${match[2]}.webp` : path;
};

export const PhoneFrame = ({ src, alt, className = "", loading = "lazy" }) => {
  const mobileSrc = mobileOnlySrc(src);
  const isV2 = V2_RE.test(mobileSrc);
  return (
    <div className={`relative overflow-hidden rounded-[2rem] border-[5px] border-[#1a1a1c] bg-black shadow-2xl ${className}`} data-testid="phone-frame">
      <span className="absolute left-1/2 top-1.5 z-10 h-4 w-20 -translate-x-1/2 rounded-full bg-[#1a1a1c]" />
      <img
        src={mobileSrc}
        alt={alt}
        loading={loading}
        width={isV2 ? 390 : undefined}
        height={isV2 ? 844 : undefined}
        className="block h-auto w-full"
      />
    </div>
  );
};
